import { AppType } from './action';
import { Middleware } from '../index';
import { redirectRequested } from '../Redirect/action';
import { postPageRequestLog } from '../../Service/ValidatorService';

export class AppMiddleware {
    public middleware: Middleware = store => next => action => {
        next(action);

        if (action.type === AppType.FinishedLoading) {
            return store.dispatch(redirectRequested(`/rente/${action.url}`));
        }

        if (action.type === AppType.ValidatorFinishedLoading) {
            void postPageRequestLog(action.caseId, action.label);
        }
    };
}
